import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { updateSEO, seoConfigs } from '../../utils/seo';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    updateSEO(seoConfigs.about);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[30vh] md:h-[35vh] w-full overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/073ffdfd35a5fea1a6549a32c662b644.jpg"
            alt="岡山市の脱毛サロン・エステ外観"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center px-6">
            <p className="text-white text-xs md:text-sm font-light mb-4 tracking-widest uppercase">
              About Us
            </p>
            <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold">
              私たちについて
            </h1>
          </div>
        </div>
      </section>

      {/* Concept Section */}
      <section className="py-20 md:py-28 bg-gray-light px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <p className="text-gray-medium text-xs md:text-sm font-light mb-4 tracking-widest uppercase">
              Our Concept
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-dark mb-8 leading-tight">
              お客様一人ひとりに寄り添う、<br />丁寧な美容体験を
            </h2>
            <div className="max-w-3xl">
              <p className="text-base md:text-lg font-light text-gray-dark/80 leading-relaxed mb-6">
                おかやま脱毛サロン・エステは、岡山市で20代女性の美しさをサポートする専門サロンとして2026年4月に新規オープンいたします。
              </p>
              <p className="text-base md:text-lg font-light text-gray-dark/80 leading-relaxed mb-6">
                私たちは「一人ひとりのお客様に最適な美容体験を提供する」ことを理念に、丁寧なカウンセリングと確かな技術で、お客様の理想の美しさを実現します。岡山市を中心とした地域の皆様に、安心して通っていただける居心地の良いサロンを目指しています。
              </p>
              <p className="text-base md:text-lg font-light text-gray-dark/80 leading-relaxed">
                最新の美容機器と熟練のスタッフによる施術で、脱毛からフェイシャルエステ、痩身ケアまで、トータルビューティーをサポートいたします。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16">
            <div className="rounded-lg overflow-hidden h-64 md:h-96">
              <img
                src="https://readdy.ai/api/search-image?query=Japanese%20female%20esthetician%20consulting%20with%20young%20Japanese%20woman%20client%20at%20modern%20beauty%20salon%2C%20professional%20counseling%20scene%2C%20clean%20white%20interior%2C%20natural%20lighting%2C%20friendly%20atmosphere%2C%20both%20women%20smiling%2C%20no%20text%20visible%2C%20simple%20elegant%20background&width=800&height=600&seq=about-counseling&orientation=landscape"
                alt="岡山市の脱毛サロンでのカウンセリング風景"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-lg overflow-hidden h-64 md:h-96">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20Japanese%20beauty%20salon%20treatment%20room%20interior%2C%20clean%20white%20minimalist%20design%2C%20professional%20equipment%2C%20bright%20natural%20lighting%2C%20elegant%20spa%20atmosphere%2C%20comfortable%20treatment%20bed%2C%20no%20text%20visible%2C%20simple%20background&width=800&height=600&seq=about-interior&orientation=landscape"
                alt="岡山市の脱毛サロン・エステの施術室"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 md:py-28 bg-white px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-16">
            <p className="text-gray-medium text-xs md:text-sm font-light mb-4 tracking-widest uppercase">
              Our Services
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-dark">
              事業内容
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <article className="bg-gray-light rounded-lg p-8">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#8C646E' }}>
                <i className="ri-sparkling-2-line text-3xl text-white w-10 h-10 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-dark mb-4">
                脱毛サービス
              </h3>
              <p className="text-sm md:text-base font-light text-gray-dark/80 leading-relaxed mb-4">
                最新の医療用脱毛機器を使用し、痛みを最小限に抑えた効果的な施術を提供します。全身脱毛から部分脱毛まで、お客様のニーズに合わせたプランをご用意しています。
              </p>
              <ul className="space-y-2 text-sm font-light text-gray-dark/70">
                <li className="flex items-start">
                  <i className="ri-check-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <span>全身脱毛コース</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <span>部分脱毛（顔・VIO・腕・脚など）</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <span>痛みの少ない最新機器使用</span>
                </li>
              </ul>
            </article>

            <article className="bg-gray-light rounded-lg p-8">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#8C646E' }}>
                <i className="ri-heart-pulse-line text-3xl text-white w-10 h-10 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-dark mb-4">
                フェイシャルエステ
              </h3>
              <p className="text-sm md:text-base font-light text-gray-dark/80 leading-relaxed mb-4">
                お肌の悩みに合わせたオーダーメイドのフェイシャルケアを提供します。毛穴ケア、美白、保湿など、20代女性の肌質に最適な施術で透明感のある美肌へ導きます。
              </p>
              <ul className="space-y-2 text-sm font-light text-gray-dark/70">
                <li className="flex items-start">
                  <i className="ri-check-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <span>毛穴ケア・クレンジング</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <span>美白・保湿トリートメント</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <span>アンチエイジングケア</span>
                </li>
              </ul>
            </article>

            <article className="bg-gray-light rounded-lg p-8">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#8C646E' }}>
                <i className="ri-body-scan-line text-3xl text-white w-10 h-10 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-dark mb-4">
                痩身ボディケア
              </h3>
              <p className="text-sm md:text-base font-light text-gray-dark/80 leading-relaxed mb-4">
                理想のボディラインを目指す専門的な痩身プログラム。ハンドマッサージと最新マシンを組み合わせた効果的なアプローチで、健康的な美しさをサポートします。
              </p>
              <ul className="space-y-2 text-sm font-light text-gray-dark/70">
                <li className="flex items-start">
                  <i className="ri-check-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <span>キャビテーション施術</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <span>リンパドレナージュ</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <span>セルライトケア</span>
                </li>
              </ul>
            </article>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 md:py-28 bg-gray-light px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-dark mb-6">
              岡山市で選ばれる理由
            </h2>
            <p className="text-base md:text-lg font-light text-gray-dark/80 max-w-3xl mx-auto leading-relaxed">
              20代女性のお客様に支持される、私たちの強みをご紹介します
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <article className="bg-white rounded-lg p-8 text-center">
              <div className="w-20 h-20 bg-gray-dark/5 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-user-heart-line text-4xl w-12 h-12 flex items-center justify-center" style={{ color: '#8C646E' }}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-dark mb-3">
                丁寧なカウンセリング
              </h3>
              <p className="text-sm md:text-base font-light text-gray-dark/80 leading-relaxed">
                お客様一人ひとりの肌質や悩みに合わせて、最適なプランをご提案します
              </p>
            </article>

            <article className="bg-white rounded-lg p-8 text-center">
              <div className="w-20 h-20 bg-gray-dark/5 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-4xl w-12 h-12 flex items-center justify-center" style={{ color: '#8C646E' }}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-dark mb-3">
                確かな技術と実績
              </h3>
              <p className="text-sm md:text-base font-light text-gray-dark/80 leading-relaxed">
                経験豊富なスタッフによる、安全で効果的な施術を提供します
              </p>
            </article>

            <article className="bg-white rounded-lg p-8 text-center">
              <div className="w-20 h-20 bg-gray-dark/5 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-home-smile-line text-4xl w-12 h-12 flex items-center justify-center" style={{ color: '#8C646E' }}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-dark mb-3">
                清潔で快適な空間
              </h3>
              <p className="text-sm md:text-base font-light text-gray-dark/80 leading-relaxed">
                リラックスできる居心地の良いサロンで、特別な時間をお過ごしください
              </p>
            </article>

            <article className="bg-white rounded-lg p-8 text-center">
              <div className="w-20 h-20 bg-gray-dark/5 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-price-tag-3-line text-4xl w-12 h-12 flex items-center justify-center" style={{ color: '#8C646E' }}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-dark mb-3">
                明確な料金体系
              </h3>
              <p className="text-sm md:text-base font-light text-gray-dark/80 leading-relaxed">
                追加料金なしの分かりやすい料金設定で、安心してご利用いただけます
              </p>
            </article>

            <article className="bg-white rounded-lg p-8 text-center">
              <div className="w-20 h-20 bg-gray-dark/5 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-map-pin-line text-4xl w-12 h-12 flex items-center justify-center" style={{ color: '#8C646E' }}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-dark mb-3">
                アクセス良好
              </h3>
              <p className="text-sm md:text-base font-light text-gray-dark/80 leading-relaxed">
                岡山市北区の好立地で、お仕事帰りやお買い物ついでに気軽に通えます
              </p>
            </article>

            <article className="bg-white rounded-lg p-8 text-center">
              <div className="w-20 h-20 bg-gray-dark/5 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-calendar-check-line text-4xl w-12 h-12 flex items-center justify-center" style={{ color: '#8C646E' }}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-dark mb-3">
                柔軟な予約対応
              </h3>
              <p className="text-sm md:text-base font-light text-gray-dark/80 leading-relaxed">
                お電話やLINEで簡単予約。お客様のスケジュールに合わせて対応します
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* Staff Section */}
      <section className="py-20 md:py-28 bg-white px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-gray-medium text-xs md:text-sm font-light mb-4 tracking-widest uppercase">
              Our Staff
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-dark">
              スタッフ紹介
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <article className="text-center">
              <div className="w-48 h-48 mx-auto rounded-full overflow-hidden mb-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20female%20esthetician%20age%2030s%2C%20friendly%20smile%2C%20white%20uniform%2C%20natural%20makeup%2C%20professional%20portrait%2C%20clean%20background%2C%20confident%20expression%2C%20beauty%20salon%20staff%20photo&width=400&height=400&seq=staff1&orientation=squarish"
                  alt="岡山市の脱毛サロン・エステのスタッフ"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-bold text-gray-dark mb-2">店長 田中 美穂</h3>
              <p className="text-sm font-light text-gray-medium mb-3">エステティシャン歴8年</p>
              <p className="text-sm font-light text-gray-dark/80 leading-relaxed">
                お客様の美しさを引き出すお手伝いができることが何よりの喜びです
              </p>
            </article>

            <article className="text-center">
              <div className="w-48 h-48 mx-auto rounded-full overflow-hidden mb-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20female%20esthetician%20age%2020s%2C%20warm%20smile%2C%20white%20uniform%2C%20natural%20makeup%2C%20professional%20portrait%2C%20clean%20background%2C%20friendly%20expression%2C%20beauty%20salon%20staff%20photo&width=400&height=400&seq=staff2&orientation=squarish"
                  alt="岡山市の脱毛サロン・エステのスタッフ"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-bold text-gray-dark mb-2">佐藤 優子</h3>
              <p className="text-sm font-light text-gray-medium mb-3">脱毛専門スタッフ</p>
              <p className="text-sm font-light text-gray-dark/80 leading-relaxed">
                丁寧な施術で、お客様に安心していただけるよう心がけています
              </p>
            </article>

            <article className="text-center">
              <div className="w-48 h-48 mx-auto rounded-full overflow-hidden mb-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20female%20esthetician%20age%2020s%2C%20gentle%20smile%2C%20white%20uniform%2C%20natural%20makeup%2C%20professional%20portrait%2C%20clean%20background%2C%20caring%20expression%2C%20beauty%20salon%20staff%20photo&width=400&height=400&seq=staff3&orientation=squarish"
                  alt="岡山市の脱毛サロン・エステのスタッフ"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-bold text-gray-dark mb-2">山田 彩</h3>
              <p className="text-sm font-light text-gray-medium mb-3">フェイシャル担当</p>
              <p className="text-sm font-light text-gray-dark/80 leading-relaxed">
                お肌の悩みに寄り添い、最適なケアをご提案いたします
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-28 px-6" style={{ backgroundColor: '#8C646E' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            まずは無料カウンセリングから
          </h2>
          <p className="text-base md:text-lg font-light text-gray-light/80 mb-10 leading-relaxed">
            お気軽にお問い合わせください
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:086-012-3456"
              className="px-8 py-3.5 bg-white text-gray-dark text-sm md:text-base font-medium rounded-full whitespace-nowrap hover:bg-gray-light transition-colors cursor-pointer inline-flex items-center"
            >
              <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              086-012-3456
            </a>
            <a
              href="/contact"
              className="px-8 py-3.5 bg-transparent border-2 border-white text-white text-sm md:text-base font-medium rounded-full whitespace-nowrap hover:bg-white hover:text-gray-dark transition-colors cursor-pointer"
            >
              お問い合わせフォーム
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;